/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */

'use strict';
angular
  .module('http.api', [])
  /**
   * Service used to access all calls to the api rest service.
   */
  .factory('httpApi', function ($http, API_TYPES, TIME_INTERVALS) {
    const urls = {
      [API_TYPES.REST_API]: {
        apiUsage: 'api/api/count',
        history: 'api/api/history',
        updateLimit: 'api/account/api'
      },
      [API_TYPES.BULK_API]: {
        apiUsage: 'api/bulk-api/count',
        history: 'api/bulk-api/history',
        updateLimit: 'api/account/bulk-api'
      }
    };

    /**
     * Get the api usage for the current day.
     *
     * @returns {Response|Error} The API data object, or an Error on failure.
     */
    var getApiUsage = function (api = API_TYPES.REST_API) {
      const url = urls[api].apiUsage;
      return $http({
        method: 'GET',
        url
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Get the api usage history.
     *
     * @returns {Response|Error} The API data object, or an Error on failure.
     */
    var getApiUsageHistory = function (api = API_TYPES.REST_API, timeInterval = TIME_INTERVALS.DAILY) {
      const url = urls[api].history;

      const params = {};
      if (api === API_TYPES.BULK_API) {
        params.timeIntervalType = timeInterval;
      }

      return $http({
        method: 'GET',
        url,
        params
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Update the allowed api calls per day.
     *
     * @returns {object} The response from the server call.  It has a single property:
     *  update that will be true if successful and false on a fail.
     */
    var updateLimit = function (newLimit, api = API_TYPES.REST_API) {
      const url = urls[api].updateLimit;
      return $http({
        method: 'POST',
        url,
        params: {
          limit: newLimit
        }
      }).then(function (res) {
        return res.data;
      });
    };

    return {
      getApiUsage: getApiUsage,
      updateLimit: updateLimit,
      getApiUsageHistory: getApiUsageHistory
    };
  });
